export default __webpack_public_path__ + "static/media/startupRealCase2-en.b29cdd51.jpg";